exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-item__tip[data-v-3851ad66]{font-style:italic;opacity:.8;display:inline-block;float:right;margin-right:1rem;font-weight:600;color:#f67e22}.collapse-item__tip[data-v-3851ad66]:hover{opacity:1}.clone-item[data-v-3851ad66]{font-style:italic;opacity:.8;display:inline-block;margin-right:1rem;font-weight:600;color:#f67e22}.drawer .el-collapse-item__header[data-v-3851ad66],.drawer .el-collapse-item__wrap[data-v-3851ad66]{background-color:#fafafa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3851ad66","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/Blocks/RequestBuilder.vue
// module id = 494
// module chunks = 0